import { createApp }    from "vue";

import DOMPurify        from 'dompurify';

import kit              from "@ramp-global/vue-kit";

import Notifications    from '@kyvg/vue3-notification';
import Version          from "@/core/version";
import { Helpers }      from "@/core/utils";

import App              from "./templates/App.vue";
import store            from "./store";

import { setupRouter }  from "./router";
import { setupI18n }    from "./i18n";

import globalProperties from "./plugins/globalProperties";

import Floating         from "floating-vue";
import                       "floating-vue/dist/style.css";

import Vue3Lottie       from 'vue3-lottie';

import { Permission }   from "@/core/permission";

import OpenReplay from "./core/openreplay";
import * as Sentry        from "@sentry/vue";
import { captureConsoleIntegration } from "@sentry/integrations";

import '@ramp-global/charts/dist/pieElement.js';
import '@ramp-global/charts/dist/guageElement.js';
import '@ramp-global/charts/dist/funnelElement.js';

( async () =>
{
    const version = new Version();
    const permission = new Permission({ store });

    const savedLocale = Helpers.Storage( undefined, 'get', 'locale' ) || 'en';
    const i18n        = await setupI18n({ legacy: false, globalInjection: true, warnHtmlMessage: false, locale: savedLocale, fallbackLocale: 'en' }); //KED BUDU SA ROBIT LOCALE ZARIAD ZE VIES TAHAT AJ ROVNO TU ABY NEBOL DUPLICITNY LOAD EN/Dalsi jazyk
    const router  = setupRouter( store, i18n, version, permission );

    const rampApp = createApp( App );

    if( ['production','test'].includes( import.meta.env.MODE ) )
    {
        OpenReplay.init( { projectKey: import.meta.env.VITE_APP_OPENREPLAY_PROJECT_KEY, ingestPoint :  import.meta.env.VITE_APP_OPENREPLAY_INGEST_POINT } );
        OpenReplay.start();
        OpenReplay.setMetadata( 'version', version.get() );
    }
    
    Sentry.init(
    {
        app                 : rampApp,
        environment         : import.meta.env.MODE,
        release             : version.get(),
        integrations        : [ captureConsoleIntegration({ levels: [ "error" ] }) ],
        ignoreErrors        : [ 'AbortError' ],
        autoSessionTracking : true,
        dsn                 : "https://7d948cf5f39653e932b1307aafef360c@o4508918496952320.ingest.de.sentry.io/4508963584868432"
    });

    rampApp.use( store )
        .use( router )
        .use( i18n )
        .use( globalProperties, { store, i18n, permission })
        .use( kit )
        .use( Notifications )
        .use( Floating, { themes: { 'tooltip-label': { $extend: 'tooltip' } } } )
        .use( Vue3Lottie )
        .directive('sanitize-html',
        {
            beforeMount( el, binding ) { el.innerHTML = DOMPurify.sanitize( binding.value, { ADD_ATTR: ['target'] } ); },
            updated( el, binding )     { el.innerHTML = DOMPurify.sanitize( binding.value, { ADD_ATTR: ['target'] } ); },
        })
        .mount( 'body' );
})();
